import { createAction } from "@reduxjs/toolkit";
import { PsychologicalAssessmentFormFields } from "../interfaces/store/IPsychologicalAssessment";
import { PsychologicalAssessmentActionsNames } from "../constants/actionTypes";

const updateEvaluationForm = createAction<Record<PsychologicalAssessmentFormFields, any>>(PsychologicalAssessmentActionsNames.UPDATE_EVALUATION_FORM)
const updateInitialEvalutationForm = createAction<Record<PsychologicalAssessmentFormFields, any>>(PsychologicalAssessmentActionsNames.UPDATE_INITIAL_EVALUATION_FORM)
export const PsychologicalAssessmentActions = {
    updateEvaluationForm,
    updateInitialEvalutationForm
}